/* ===========================================================================
   mega-menu.js  —  Keyboard enhancements for the mega menu
   ---------------------------------------------------------------------------
   PURELY ADDITIVE. The mega menu is fully usable with this file removed:
   opening, closing, hover intent and focus handling all come from the theme's
   own <hover-disclosure> element. This script only layers on the keyboard
   conveniences shoppers expect from a large multi-column menu.

   Deliberately does NOT call into <hover-disclosure> internals (an undocumented
   theme API that could change on theme update). To close a panel it simply
   moves focus back to the top-level link and lets the theme's existing focus
   management close it — behaviour that survives theme updates.
   =========================================================================== */

(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled])';

  /**
   * Collect the focusable links inside a mega panel, in visual order.
   */
  function panelLinks(panel) {
    return Array.prototype.filter.call(
      panel.querySelectorAll(FOCUSABLE),
      function (el) {
        // Skip anything hidden (e.g. a collapsed column at a narrow width).
        return el.offsetParent !== null;
      }
    );
  }

  function handleKeydown(event) {
    if (!event.target || !event.target.closest) return;

    var panel = event.target.closest('.header__dropdown--mega');
    if (!panel) return;

    var disclosure = panel.closest('.mega-menu');
    if (!disclosure) return;

    var topLink = disclosure.querySelector('[data-top-link]');
    var links = panelLinks(panel);
    var currentIndex = links.indexOf(event.target);

    switch (event.key) {
      // Escape: hand focus back to the top-level item. The theme's focus
      // handling closes the panel from there.
      case 'Escape':
        event.preventDefault();
        if (topLink) topLink.focus();
        break;

      // Down / Up: move through links within the panel.
      case 'ArrowDown':
      case 'ArrowUp': {
        if (currentIndex === -1) return;
        event.preventDefault();

        var step = event.key === 'ArrowDown' ? 1 : -1;
        var nextIndex = currentIndex + step;

        if (nextIndex >= 0 && nextIndex < links.length) {
          links[nextIndex].focus();
        } else if (nextIndex < 0 && topLink) {
          // Arrowing up past the first link returns to the top-level item.
          topLink.focus();
        }
        break;
      }

      // Home / End: jump to first or last link in the panel.
      case 'Home':
        if (currentIndex === -1 || !links.length) return;
        event.preventDefault();
        links[0].focus();
        break;

      case 'End':
        if (currentIndex === -1 || !links.length) return;
        event.preventDefault();
        links[links.length - 1].focus();
        break;

      default:
        break;
    }
  }

  /**
   * Delegate from the document so panels re-rendered by the theme editor are
   * covered without needing to re-bind.
   */
  document.addEventListener('keydown', handleKeydown);
})();
